import app from "firebase/app";
import {firebaseConfig} from "../constants";
const initApp = () => {
    app.initializeApp(firebaseConfig);
    app.analytics();
    // 
  };

export default initApp;